export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/photogallery/deleteEventPhoto',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['eventPhotos'],
       
    })
